var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#fb3f6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#f12357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.857,
    x2: 186.583,
    xlinkHref: "#lg1",
    y1: 320.394,
    y2: 446.121
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-1 0 0 1 284.325 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -164.818,
    x2: -39.092,
    xlinkHref: "#lg1",
    y1: 320.394,
    y2: 446.121
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(1 .002 -.002 1 .881 -.839)",
    gradientUnits: "userSpaceOnUse",
    x1: 416.762,
    x2: 275.886,
    y1: 410.094,
    y2: 356.891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.644,
    x2: 365.953,
    xlinkHref: "#lg2",
    y1: 251.906,
    y2: 251.906
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e3e9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518cd2"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.45,
    x2: 73.617,
    xlinkHref: "#lg3",
    y1: 281.536,
    y2: 165.206
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.283,
    x2: 197.005,
    xlinkHref: "#lg2",
    y1: 266.626,
    y2: 155.348
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.474,
    x2: 292.965,
    xlinkHref: "#lg2",
    y1: 168.817,
    y2: 251.308
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.541,
    x2: 289.498,
    y1: 172.883,
    y2: 247.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.534,
    x2: 319.665,
    xlinkHref: "#lg1",
    y1: 40.528,
    y2: 40.528
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.306,
    x2: 381.784,
    y1: 456.476,
    y2: 456.476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.576,
    x2: 433.418,
    xlinkHref: "#lg3",
    y1: 394.965,
    y2: 308.041
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1551,
    stopColor: "#9b489a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4019,
    stopColor: "#84438f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#5e3b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.519,
    x2: 194.273,
    xlinkHref: "#lg4",
    y1: 478.643,
    y2: 502.217
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.332,
    x2: 224.085,
    xlinkHref: "#lg4",
    y1: 478.643,
    y2: 502.217
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.145,
    x2: 253.898,
    xlinkHref: "#lg4",
    y1: 478.643,
    y2: 502.217
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.958,
    x2: 283.711,
    xlinkHref: "#lg4",
    y1: 478.643,
    y2: 502.217
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.771,
    x2: 313.524,
    xlinkHref: "#lg4",
    y1: 478.643,
    y2: 502.217
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.583,
    x2: 343.336,
    xlinkHref: "#lg4",
    y1: 478.643,
    y2: 502.217
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m176.857 399.025 4.141-2.055v-113.982l-46.694 23.167c-33.587 16.664-54.832 50.92-54.832 88.414v96.857c0 6.841 5.545 12.386 12.386 12.386 5.208 0 9.859-3.258 11.64-8.152l8.946-24.594c11.42-31.396 34.485-57.193 64.413-72.041z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m333.143 399.025-4.141-2.055v-113.982l46.694 23.167c33.587 16.664 54.832 50.92 54.832 88.414v96.857c0 6.841-5.545 12.386-12.386 12.386-5.208 0-9.859-3.258-11.64-8.152l-8.946-24.594c-11.42-31.396-34.485-57.193-64.413-72.041z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m356.771 296.601-27.515-13.73-.262 113.982 4.136 2.064c29.894 14.917 52.899 40.767 64.248 72.189l8.89 24.614c1.769 4.898 6.413 8.167 11.621 8.179 6.841.016 12.399-5.517 12.415-12.358l.223-96.856c.022-9.627-1.366-19.04-3.996-28.004z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m282.277 16.926c-14.29-23.5-40.069-21.618-54.553 0-39.613 62.555-74.892 138.412-75.002 223.717-.211 77.789 4.65 154.917 14.579 231.362 2.362 18.19 17.852 31.806 36.194 31.806h103.01c18.342 0 33.832-13.616 36.194-31.806 9.929-76.445 14.791-153.573 14.579-231.362-.569-85.568-35.164-160.809-75.001-223.717z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m282.276 16.926c-7.162-11.778-17.21-17.178-27.276-16.914v503.8h51.505c18.342 0 33.831-13.616 36.194-31.806 9.929-76.445 14.791-153.573 14.579-231.362-.569-85.569-35.164-160.81-75.002-223.718z",
    fill: "url(#SVGID_5_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 213.343,
    fill: "url(#SVGID_6_)",
    r: 60.128
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 213.343,
    fill: "url(#SVGID_7_)",
    r: 38.889
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 213.343,
    fill: "url(#SVGID_8_)",
    r: 35.337
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m255 81.056c21.234 0 41.407-2.476 59.612-6.925-9.894-20.052-20.895-39.139-32.335-57.204-14.29-23.5-40.069-21.618-54.553 0-11.395 17.994-22.424 37.093-32.367 57.196 18.212 4.453 38.397 6.933 59.643 6.933z",
    fill: "url(#SVGID_9_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m163.169 437.368c1.267 11.561 2.635 23.108 4.132 34.638.158 1.215.378 2.408.65 3.579h174.098c.272-1.171.492-2.364.65-3.579 1.498-11.53 2.866-23.077 4.132-34.638z",
    fill: "url(#SVGID_10_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m153.715 304.759c1.871 56.101 6.391 111.855 13.586 167.247 2.362 18.19 17.852 31.806 36.194 31.806h103.01c18.342 0 33.831-13.616 36.194-31.806 7.195-55.392 11.714-111.146 13.586-167.247z",
    fill: "url(#SVGID_11_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m185.91 510h-10.884c-5.227 0-9.464-4.237-9.464-9.464v-22.931c0-5.227 4.237-9.464 9.464-9.464h10.884c5.227 0 9.464 4.237 9.464 9.464v22.931c0 5.227-4.237 9.464-9.464 9.464z",
    fill: "url(#SVGID_12_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m215.723 510h-10.885c-5.227 0-9.464-4.237-9.464-9.464v-22.931c0-5.227 4.237-9.464 9.464-9.464h10.885c5.227 0 9.464 4.237 9.464 9.464v22.931c0 5.227-4.237 9.464-9.464 9.464z",
    fill: "url(#SVGID_13_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m245.536 510h-10.885c-5.227 0-9.464-4.237-9.464-9.464v-22.931c0-5.227 4.237-9.464 9.464-9.464h10.885c5.227 0 9.464 4.237 9.464 9.464v22.931c0 5.227-4.237 9.464-9.464 9.464z",
    fill: "url(#SVGID_14_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m275.349 510h-10.885c-5.227 0-9.464-4.237-9.464-9.464v-22.931c0-5.227 4.237-9.464 9.464-9.464h10.885c5.227 0 9.464 4.237 9.464 9.464v22.931c0 5.227-4.237 9.464-9.464 9.464z",
    fill: "url(#SVGID_15_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m305.161 510h-10.885c-5.227 0-9.464-4.237-9.464-9.464v-22.931c0-5.227 4.237-9.464 9.464-9.464h10.885c5.227 0 9.464 4.237 9.464 9.464v22.931c.001 5.227-4.237 9.464-9.464 9.464z",
    fill: "url(#SVGID_16_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m334.974 510h-10.884c-5.227 0-9.464-4.237-9.464-9.464v-22.931c0-5.227 4.237-9.464 9.464-9.464h10.884c5.227 0 9.464 4.237 9.464 9.464v22.931c0 5.227-4.237 9.464-9.464 9.464z",
    fill: "url(#SVGID_17_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRocket);
export default __webpack_public_path__ + "static/media/icon-rocket.b059364eb8ab7fd1ade2377222a78fbf.svg";
export { ForwardRef as ReactComponent };